module.exports = __webpack_public_path__ + "static/media/r-bahn~YjchbUqG.99298263.svg";